import React from "react";
import LoadingScreen from "components/common/Loading";
import { toast } from "react-toastify";
import { useCurrentUser, resetCurrentUser } from "services/currentUserService";
import { updateUser } from "services/userService";
import UserProfileForm from "./users/UserProfileForm";

const Profile = (props) => {
  const { data: userdata, loading } = useCurrentUser();

  const dateFormatter = (dataToChange) => {
    let data = { ...dataToChange };
    data.dateJoined =
      data.dateJoined !== null ? new Date(data.dateJoined) : null;
    data.dateQualified =
      data.dateQualified !== null ? new Date(data.dateQualified) : null;
    data.dateOfBirth =
      data.dateOfBirth !== null ? new Date(data.dateOfBirth) : null;
    data.dateLeft = data.dateLeft !== null ? new Date(data.dateLeft) : null;
    return data;
  };

  const refreshCurrentUserData = async () => {
    try {
      await resetCurrentUser();
    } catch (error) {
      console.error("Error refreshing current user data:", error);
    }
  };

  const submitHandler = async (e) => {
    try {
      var datasent = e;
      const res = await updateUser(userdata.userID, datasent);
      if (res.success) {
        toast.success("Profile Updated");
      }
    } catch (error) {
      toast.error("Error updating profile");
    }
  };

  return (
    <>
      {loading && <LoadingScreen />}
      <UserProfileForm
        mode="profile"
        initialData={dateFormatter(userdata)}
        onSubmit={submitHandler}
        onRefreshUser={refreshCurrentUserData}
      />
    </>
  );
};
export default Profile;
